"use client";
import { SelectItem } from "@/components/ui/select";

export function Selectors({ collectionHandle }) {
  switch (collectionHandle) {
    case "showbags":
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
          <SelectItem value="low-high">Price: Low to High</SelectItem>
          <SelectItem value="high-low">Price: High to Low</SelectItem>
        </>
      );
    case "rides":
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
          <SelectItem value="low-high">Price: Low to High</SelectItem>
          <SelectItem value="high-low">Price: High to Low</SelectItem>
        </>
      );
    case "commercial_exhibitors":
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
        </>
      );
    case "food_outlets":
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
        </>
      );
    case "competitions":
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
        </>
      );
    case "events":
      return (
        <>
          <SelectItem value="time-grouped">Time (Morning/Afternoon)</SelectItem>
        </>
      );
    default:
      return (
        <>
          <SelectItem value="a-z">A-Z</SelectItem>
          <SelectItem value="z-a">Z-A</SelectItem>
        </>
      );
  }
}
